<template>
    <div>
        <el-drawer
            title="预览"
            :visible.sync="drawerShow"
            :wrapperClosable="true"
            :destroy-on-close="true"
            size="auto"
            @close="close"			
        >
            <div class="drawer-content">
                <template>
                   <!-- <h2 class="name">{{codeData.name}}</h2> -->
                    <div class="code">
                        <vue-qr :logoSrc="logo" :text="redeemUrl" :size="800" :logoMargin="8" logoBackgroundColor="#ffffff" :callback="getImage" :margin="0"></vue-qr>
                        <input class="copyTool" ref="copyTool" :value="redeemUrl" />
                    </div>                    
                    <div class="MT10"> 
                        <el-button size="small" plain type="primary" @click="$refs.H5Preview.show(redeemUrl)">直接打开</el-button>
						<el-button type="primary" size="small" @click="copy">复制链接</el-button>
						<el-button type="primary" size="small" @click="downloadCode">下载二维码</el-button>
                    </div>
					<!-- <div class="code MT30" v-if="codeData.wechatCodeUrl" >
					    <img :src="codeData.wechatCodeUrl" class="img2" >
					    <input class="copyTool" ref="copyTool" :value="codeData.copyUrl" />
					</div>
					<div class="MT10" v-if="codeData.wechatCodeUrl">					    
						<el-button type="primary" size="small" @click="downloadCodeWechat(codeData.wechatCodeUrl)" >下载二维码</el-button>
					</div>
                    <template v-if="codeData.redbookLink">
                        <div class="MT30">
                            <h2 class="name">小红书分享链接</h2>
                            <div class="code">
                                <vue-qr :text="codeData.redbookLink" :size="800" :logoMargin="8" logoBackgroundColor="#ffffff" :callback="getImage" :margin="0"></vue-qr>
                                <input class="copyTool2" ref="copyTool2" :value="codeData.redbookLink" />
                            </div>    
                            <div class="color-success MT10 MB20"> {{codeData.redbookLink}} </div>
                            <el-button type="primary" size="small" @click="copy2">复制链接</el-button>
                        </div>
                    </template> -->
                </template>
            </div>
            <div class="drawer-footer">
                <el-button  @click="close">关闭</el-button>
            </div>
        </el-drawer>
        <H5Preview ref="H5Preview"></H5Preview>
    </div>
</template>

<script>
import VueQr from 'vue-qr'
import logo from '@/assets/img/logo.png';
import H5Preview from '@/components/H5Preview';
export default {
    components:{VueQr,H5Preview},
    data(){
        return{
            drawerShow: false,
            codeData:null,
            logo:logo,
            codeImage:'',
            copyTimer: null,
			copyTimer2: null,
            sswap:process.env.VUE_APP_SSWAP_URL,
			wechatcodeLoading:false,
			redeemUrl: `${process.env.VUE_APP_SSWAP_URL}/pages/coupon/redeem`,
			//是否展示小程序码,0是展示，1是展示
        }
    },
    methods:{
        close(){
            this.drawerShow = false
        },
        show(){			
    //         this.codeData = {
    //             ...obj,
    //             name: obj.name || obj.title,
    //             copyUrl: obj.qrCodeUrl,
				// wechatCodeUrl:obj.wechatCodeUrl || '',
				// redbookLink: obj.redBookUrl || obj.Link,
				// activityId:obj.id,
    //         };
            // this.codeData.qrCodeUrl += this.codeData.qrCodeUrl.includes('?') ? "&" : "?";
            // this.codeData.qrCodeUrl += "previewFrom=admin"
			
            this.drawerShow = true
			
			// if( !this.codeData.wechatCodeUrl && this.codeData.showWechart == 1){
			// 	this.getWechatcode()
			// }
			
			
        },
        getImage(url){
            this.codeImage = url;
        },
        downloadCode(){
            const _data = this.$utils.base64ToBlob(this.codeImage);
            this.$utils.exportFile(_data,`兑换码明细二维码.png`);
        },
		downloadCodeWechat(imgUrl){
		    const url = imgUrl
		    const fileName = this.codeData.name + '-小程序码.jpg'
		    this.$utils.downloadImg(url,fileName);
		},
		getWechatcode() {
			this.wechatcodeLoading = true
		    this.$request({
		        url: "/activity/getWeChatMiniQrCode",
		        method: "post",
		        params: { activityId: this.codeData.activityId }
		    }).then(res => {
		        const { state, result } = res.data;
		        if (state == 1) {
					this.wechatcodeLoading = false
		            this.codeData.wechatCodeUrl = result
		        }
		    })
		},
        //复制链接
        copy(){
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
		//复制小红书分享链接
		copy2(){
		    clearTimeout(this.copyTimer);
		    this.copyTimer2 = setTimeout(() => {
		        const e = this.$refs.copyTool2;
		        e.select();
		        document.execCommand("Copy"); // 执行浏览器复制命令
		        this.$message.success("已复制成功，可粘贴");
		    },300)
		},
    }
}
</script>

<style lang="scss" scoped>
.drawer-content{
    text-align: center;
    .name{
        font-size: 14px;
        line-height: 20px;
    }
    .code{
        width: 200px;
        height: 200px;
        margin: 15px auto;
        img{
            width: 100%;
            max-width: 100%;
        }
    }
}
.copyTool,.copyTool2{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>